// extracted by mini-css-extract-plugin
export var layoutContainer = "_cy-0";
export var layoutContainerNoRounding = "_cy-6";
export var layoutContainerOpen = "_cy-5";
export var layoutContainerResizing = "_cy-1";
export var mainContent = "_cy-2";
export var resizeDivider = "_cy-3";
export var slidePanel = "_cy-4";